<div class="referral">
<h2 mat-dialog-title>{{ data.message }}</h2>

<mat-dialog-actions>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn mx-2" (click)="onSuccessResponse()">Submit Referral</button>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onNegativeResponse()">Edit Policy Inception Date</button>
</mat-dialog-actions>
</div>